import { useCallback } from "react";
import { DeficiencyReview } from "../types/deficiency.types";
import { ActiveWorkerDto } from "../types/work.types";
import { useAuthenticatedRequestService } from "./service.base";

export function useDeficiencyReviewService() {
  const { authGet, authPost } = useAuthenticatedRequestService();

  const getReviewableDeficiencyCountByMatter = useCallback(
    async function (matterId: string): Promise<number> {
      const deficiencyIds = await authGet(`matters/${matterId}/deficiency/reviews`);
      return deficiencyIds.length;
    },
    [authGet]
  );
  const getNextReviewableDeficiencyByMatter = useCallback(
    async function (matterId: string): Promise<DeficiencyReview> {
      return await authGet(`matters/${matterId}/deficiency/reviews/next`);
    },
    [authGet]
  );

  const postDeficiencyReview = useCallback(
    async function (matterId: string, deficiencyReview: DeficiencyReview): Promise<DeficiencyReview> {
      return await authPost(`matters/${matterId}/deficiency/reviews`, deficiencyReview);
    },
    [authPost]
  );

  const postDeficiencyReviewBreak = useCallback(
    async function (deficiencyId: string): Promise<void> {
      return await authPost(`deficiency/reviews/break`, { deficiencyId: parseInt(deficiencyId, 10) });
    },
    [authPost]
  );

  const getActiveDeficiencyReviewers = useCallback(
    async function (matterId: number): Promise<ActiveWorkerDto[]> {
      return await authGet(`matters/${matterId}/deficiency/queue`);
    },
    [authGet]
  );

  const unassignDeficiencyReviewer = useCallback(
    async function (matterId: number, userId: number): Promise<{ unassignedCount: number }> {
      return await authPost(`matters/${matterId}/deficiency/queue/${userId}/unassign`, {});
    },
    [authPost]
  );

  const unassignAllDeficiencyReviewers = useCallback(
    async function (matterId: number): Promise<{ unassignedCount: number }> {
      return await authPost(`matters/${matterId}/deficiency/queue/unassign-all`, {});
    },
    [authPost]
  );

  const funcs = {
    getReviewableDeficiencyCountByMatter,
    getNextReviewableDeficiencyByMatter,
    postDeficiencyReview,
    postDeficiencyReviewBreak,
    getActiveDeficiencyReviewers,
    unassignDeficiencyReviewer,
    unassignAllDeficiencyReviewers,
  };
  return funcs;
}
